import React from 'react';
import styled, {keyframes} from 'styled-components'
import background from '../images/alternativebackground.png'
import {Link} from 'react-router-dom'
import Navbar from './Navbar';
import {Linkedin , Github ,Chat , MailOption} from 'grommet-icons'
import { fadeIn } from 'react-animations';

const FadeInAnimation = keyframes`${fadeIn}`;

const Container = styled.div`
width:100%;
background: url(${background});
background-size:cover;                      /* <------ */
background-repeat:no-repeat;
margin: 0 auto;
animation: 0.8s ${FadeInAnimation};
color:#EAE1E1;
@media (max-height:880px) {
    width:100%;
    
}

@media (max-width:512px) {
    width:100%;
    height:100%;
}

@media (min-height:900px){
    width:100%;
    min-height:100vh;
}
`


const ContactWrapper = styled.div`
width:90%;
text-align:left;
margin: 0 auto;
display:grid;
font-family: 'Raleway', sans-serif;
grid-template-columns: repeat(1,auto);
grid-gap:10px;

@media (min-width:750px) {
    margin-top:50px;
}

@media (min-height:900px){
    grid-gap:40px;
}

@media (max-height:512px){
    grid-gap:20px;
}

`

const ContactLink = styled.div`
width:300px;
margin-left:15px;
padding:5px;
height:fit-content;
text-align:left;
text-decoration: underline white;
color: white;
font-size:40px;
transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
cursor:pointer;

@media (max-width:512px){
   font-size:25px;
   margin-top:10px;
   width:fit-content;
}

&:hover{
    background: white;
    color:black;
    transform: translateY(-10px);
}
`

const Contact = () => {
    const emailme = 'merkmoi2@gmail.com'
    return ( 
        <Container>
            <Navbar/>
            <ContactWrapper>
                <ContactLink 
                     onClick={()=>{window.open("mailto:"+ emailme, "emailWindow")}} data-rel="external">
                         <p><MailOption color='white' size='large' style={{marginRight:'20px'}}/>E-mail</p>
                </ContactLink>
                <ContactLink onClick={()=> {window.open('https://www.m.me/markolachow', '_blank')}}><p><Chat color='white' size='large' style={{marginRight:'20px'}}/>Messenger</p></ContactLink>
                <ContactLink onClick={()=> {window.open('https://www.linkedin.com/in/marcomoi/', '_blank')}}><p><Linkedin color='white' size='large' style={{marginRight:'20px'}}/>Linkedin</p></ContactLink>
                <ContactLink onClick={()=> {window.open('https://github.com/iizmerk', '_blank')}}><p><Github color='white' size='large' style={{marginRight:'20px'}}/>Github</p></ContactLink>
            </ContactWrapper>
        </Container>
        
        );
}
 
export default Contact;